import { render } from "./post_template.vue?vue&type=template&id=6e929f34&scoped=true"
import script from "./post_template.vue?vue&type=script&lang=js"
export * from "./post_template.vue?vue&type=script&lang=js"

import "./post_template.vue?vue&type=style&index=0&id=6e929f34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e929f34"]])

export default __exports__